function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "ToolMoreOptions_Hover",
  transform: "translate(.137)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_24",
  className: "background",
  "data-name": "Ellipse 24",
  cx: 20,
  cy: 20,
  r: 20,
  transform: "translate(-.137)",
  fill: "#98c3d9"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_978",
  className: "dots",
  "data-name": "Group 978",
  transform: "translate(1.246 1.122)",
  fill: "#002d56"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_70",
  "data-name": "Ellipse 70",
  cx: 2.314,
  cy: 2.314,
  r: 2.314,
  transform: "translate(16.617 24.356)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_71",
  "data-name": "Ellipse 71",
  cx: 2.314,
  cy: 2.314,
  r: 2.314,
  transform: "translate(16.617 16.617)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_72",
  "data-name": "Ellipse 72",
  cx: 2.314,
  cy: 2.314,
  r: 2.314,
  transform: "translate(16.617 8.878)"
})));

function SvgOptionsRound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionsRound);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgdmlld0JveD0iMCAwIDQwIDQwIj4KICA8ZyBpZD0iVG9vbE1vcmVPcHRpb25zX0hvdmVyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjEzNykiPgogICAgPGNpcmNsZSBpZD0iRWxsaXBzZV8yNCIgY2xhc3M9ImJhY2tncm91bmQiIGRhdGEtbmFtZT0iRWxsaXBzZSAyNCIgY3g9IjIwIiBjeT0iMjAiIHI9IjIwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMC4xMzcgMCkiIGZpbGw9IiM5OGMzZDkiLz4KICAgIDxnIGlkPSJHcm91cF85NzgiIGNsYXNzPSJkb3RzIiBkYXRhLW5hbWU9Ikdyb3VwIDk3OCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMS4yNDYgMS4xMjIpIj4KICAgICAgPGNpcmNsZSBpZD0iRWxsaXBzZV83MCIgZGF0YS1uYW1lPSJFbGxpcHNlIDcwIiBjeD0iMi4zMTQiIGN5PSIyLjMxNCIgcj0iMi4zMTQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE2LjYxNyAyNC4zNTYpIiBmaWxsPSIjMDAyZDU2Ii8+CiAgICAgIDxjaXJjbGUgaWQ9IkVsbGlwc2VfNzEiIGRhdGEtbmFtZT0iRWxsaXBzZSA3MSIgY3g9IjIuMzE0IiBjeT0iMi4zMTQiIHI9IjIuMzE0IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNi42MTcgMTYuNjE3KSIgZmlsbD0iIzAwMmQ1NiIvPgogICAgICA8Y2lyY2xlIGlkPSJFbGxpcHNlXzcyIiBkYXRhLW5hbWU9IkVsbGlwc2UgNzIiIGN4PSIyLjMxNCIgY3k9IjIuMzE0IiByPSIyLjMxNCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTYuNjE3IDguODc4KSIgZmlsbD0iIzAwMmQ1NiIvPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };